var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center parent-wrapper"},[_c('div',{staticClass:"image-wrapper",style:(_vm.styles)},[_c('img',{staticClass:"product-image img-fluid w-100",style:(_vm.imageStyles),attrs:{"src":_vm.product.backgroundImage}})]),_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.product.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }